import store from "@/store";
import {
  Module,
  VuexModule,
  Mutation,
  Action,
  getModule,
  MutationAction,
} from "vuex-module-decorators";
import { VeiculoModel } from "@/models/cadastros/assistencia/veiculo/VeiculoModel";
import { consultaVeiculoService } from "@/service/ConsultaVeiculoService";
@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "consulta-veiculo",
})
class ConsultaVeiculo extends VuexModule {
  veiculos: VeiculoModel[] | null = null;

  @Mutation
  SET_VEICULOS(payload: VeiculoModel[]) {
    this.veiculos = payload;
  }

  @MutationAction({ mutate: ["veiculos"], rawError: true })
  async obterDadosVeiculo(placa: string): Promise<any> {
    const dadosVeiculo = await consultaVeiculoService.obterVeiculos(placa);
    return {
      veiculos: dadosVeiculo,
    };
  }

  @MutationAction({ mutate: ["veiculos"], rawError: true })
  async obterDadosVeiculoChassi(chassi: string): Promise<any> {
    const dadosVeiculo = await consultaVeiculoService.obterVeiculosChassi(chassi);
    return {
      veiculos: dadosVeiculo,
    };
  }

  @MutationAction({ mutate: ["veiculos"], rawError: true })
  async obterDadosVeiculoAssistencia(placa: string): Promise<any> {
    const dadosVeiculo = await consultaVeiculoService.obterVeiculosAsistencia(placa);
    return {
      veiculos: dadosVeiculo,
    };
  }
}

export const consultaVeiculoModule = getModule(ConsultaVeiculo);
